import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { StoreService } from '../store/store.service';
import { GlobalStore } from '@store/global.state';

/**
 * Guard de autenticación que usa el singleton del StoreService
 * Protege rutas verificando si el usuario está logueado
 */
export const authGuard: CanActivateFn = async (route, state) => {
  
  const router = inject(Router);
  // Inyectar el servicio normalmente para asegurar inicialización
  const storeService = inject(StoreService);
  
  // Verificar si el usuario está autenticado usando el computed del store
  const isAuthenticated = storeService.global.isAuthenticated();
  if (isAuthenticated) {
    return true;
  } else {
    // Si no está autenticado, redirigir al login
    return router.createUrlTree(['/login']);
  }
};

/**
 * Guard de administrador que usa el singleton del StoreService
 * Protege rutas verificando si el usuario es administrador
 */
export const adminGuard: CanActivateFn = (route, state) => {
  
  // Inyectar el servicio normalmente para asegurar inicialización
  const global = inject(GlobalStore);
  var canActivate = global.isAdmin();
  if(!canActivate){
    const router = inject(Router);
    router.navigate(['/noExist']);
    return false;
  }
  return canActivate;
  
};

export const adminClientGuard: CanActivateFn = (route, state) => {
  
  // Inyectar el servicio normalmente para asegurar inicialización
  const global = inject(GlobalStore);
  var canActivate = global.isAdmin() || (global.isClient() && global.userClient()?.is_superadmin);
  if(!canActivate){
    const router = inject(Router);
    router.navigate(['/noExist']);
    return false;
  }
  return canActivate;
  
};



/**
 * Guard de administrador que usa el singleton del StoreService
 * Protege rutas verificando si el usuario es administrador
 */
export const clientGuard: CanActivateFn = (route, state) => {
  
  // Inyectar el servicio normalmente para asegurar inicialización
  const global = inject(GlobalStore);
  var canActivate = global.isClient() ;
    if(!canActivate){
    const router = inject(Router);
    router.navigate(['/noExist']);
    return false;
  }
  return canActivate;
  
};
/**
 * Guard de administrador que usa el singleton del StoreService
 * Protege rutas verificando si el usuario es administrador
 */
export const clientAdminGuard: CanActivateFn = (route, state) => {

  // Inyectar el servicio normalmente para asegurar inicialización
  const global = inject(GlobalStore);
  var canActivate = global.isAdmin() || (global.isClient() && global.userClient()?.is_superadmin);
    if(!canActivate){
    const router = inject(Router);
    router.navigate(['/noExist']);
    return false;
  }
  return canActivate;

};

/**
 * Guard inverso - para rutas que solo deben ser accesibles si NO está logueado (como login)
 * Redirige al app si ya está autenticado
 */
export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  
  // Usar el singleton del StoreService
  const storeService = inject(StoreService);
  
  // Verificar si el usuario está autenticado
  const isAuthenticated = storeService.global.isAuthenticated();
  
  if (!isAuthenticated) {
    return true;
  } else {
    // Redirigir al app si ya está autenticado
    router.navigate(['/transports']);
    return false;
  }
};